/**
 * path 菜单路径
 * name 菜单名称
 * icon 菜单小图标
 * headerName 子集菜单标头
 * children 菜单子集
 */
import { t } from "@/languages";
const menuList = [
  // {
  //   path: "/apply/crossStore",
  //   name: t("跨境开店"),
  //   icon: "",
  //   activeIcon: "",
  //   badge: "1688官方",
  //   children: [],
  // },
  {
    path: "/apply/collection",
    name: t("选品采集"),
    icon: "dfx-iconfont icon-shangpintongbu-xian",
    activeIcon: "dfx-iconfont icon-shangpinguanli-mian",
    headerName: "",
    children: [
      {
        path: "/apply/collection/index",
        name: t("选品采集"),
        icon: "",
        children: [],
        badge: "1688官方",
      },
      {
        path: "/apply/collection/log",
        name: t("采集记录"),
        icon: "",
        children: [],
      },
    ],
  },
  {
    path: "/apply/temuSemi",
    name: t("TEMU半托管"),
    img: "//oss.dianleida.net/1688-web/images/platform_logos/pdd-logo.png",
    headerName: "",
    children: [
      {
        path: "/apply/temuSemi/productManage/publish",
        name: t("刊登记录"),
        icon: "el-icon-s-promotion",
        children: [],
      },
      {
        path: "/apply/temuSemi/productManage/online",
        name: t("在线商品"),
        icon: "el-icon-s-promotion",
        children: [],
      },
      {
        path: "/apply/orderManage",
        name: t("订单管理"),
        icon: "dfx-iconfont icon-tongbujilu-xian",
        activeIcon: "dfx-iconfont icon-tongbujilu-mian",
        children: [],
      },
      {
        path: "/apply/purchase",
        name: t("备货采购"),
        icon: "dfx-iconfont icon-beihuocaigou-xian",
        activeIcon: "dfx-iconfont icon-beihuocaigou-mian",
        children: [],
      },
      {
        path: "/apply/productTemplate",
        name: t("产品模板"),
        icon: "dfx-iconfont icon-beihuocaigou-xian",
        activeIcon: "dfx-iconfont icon-beihuocaigou-mian",
        children: [],
      },
    ],
  },
  {
    path: "/apply/temuFully",
    name: t("TEMU全托管"),
    img: "//oss.dianleida.net/1688-web/images/platform_logos/pdd-logo.png",
    headerName: "",
    children: [
      {
        path: "/apply/temuFully/productManage/publish",
        name: t("刊登记录"),
        icon: "el-icon-s-promotion",
        children: [],
      },
      {
        path: "/apply/temuFully/productManage/online",
        name: t("在线商品"),
        icon: "el-icon-s-promotion",
        children: [],
      },
      {
        path: "/apply/temuFully/productTemplate",
        name: t("产品模板"),
        icon: "dfx-iconfont icon-beihuocaigou-xian",
        activeIcon: "dfx-iconfont icon-beihuocaigou-mian",
        children: [],
      },
    ],
  },

  {
    path: "/apply/personalManage",
    name: t("个人中心"),
    icon: "el-icon-user",
    activeIcon: "el-icon-user-solid",
    children: [
      {
        path: "/apply/personalManage/shopManage",
        name: t("店铺管理"),
        icon: "dfx-iconfont icon-mendianguanli-xian",
        activeIcon: "dfx-iconfont icon-mendianguanli-mian",
        children: [],
      },
      {
        path: "/apply/personalManage/toolOrder",
        name: t("工具订购"),
      },
      {
        path: "/apply/personalManage/myOrder",
        name: t("我的订购"),
      },
      {
        path: "/apply/personalManage/supplyAccount",
        name: t("货源账号"),
      },
      {
        path: "/apply/personalManage/logisticsManage",
        name: t("物流商管理"),
      },

    ],
  },
];

export default menuList;
